var gql = require("@apollo/client").gql;

const FILTERS_TARIFFS_ADDRESS_QUERY = gql`
	query FILTERS_TARIFFS_ADDRESS_QUERY($houseId: Int!) {
		filtersTariffsAddress(house_id: $houseId) {
			providers {
				id
				name
				translit_name
			}
		}
	}
`;

module.exports = FILTERS_TARIFFS_ADDRESS_QUERY;
